var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEllipsis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.506,
    cy: 8,
    r: 2,
    stroke: "#595959",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.006,
    cy: 8,
    r: 2.5,
    stroke: "#595959",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.506,
    cy: 8,
    r: 3,
    stroke: "#595959",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "./fonts/ellipsis.a4024dc11cdf39a1e2888bd8b8f1df70.svg";
export { SvgEllipsis as ReactComponent };